import { Component } from '@angular/core';
import { UrlService } from '../../../services/url.service';
import { ServiceRequestAction, ServiceRequestService } from '../../../services/service-request.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { ServiceRequestStatus } from '../../../types/api-response/service-request/service-request-status';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'service-request-list',
    templateUrl: './service-request-list.component.html',
    styleUrls: ['./service-request-list.component.scss']
})
export class ServiceRequestListComponent {
    action = ServiceRequestAction;

    constructor(
        public urlService: UrlService,
        public serviceRequestService: ServiceRequestService,
        public authenticationService: AuthenticationService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.serviceRequestService.data.allServiceRequests.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    changeServiceRequestReadStatus(event, isRead, request) {
        this.serviceRequestService.isReadStatusForChange = isRead;
        this.serviceRequestService.serviceRequestInServiceRequestModal = request;
        this.serviceRequestService.showAddCommentModal = true;
        event.stopPropagation();
    }

    changeServiceRequestStatus(event, status, request) {
        if (!status) return;
        this.serviceRequestService.statusForChange = status;
        this.serviceRequestService.serviceRequestInServiceRequestModal = request;
        this.serviceRequestService.showAddCommentModal = true;
        event.stopPropagation();
    }

    assignServiceRequestTo(request, event) {
        this.serviceRequestService.statusForChange = ServiceRequestStatus.inProgress;
        this.serviceRequestService.showAssignToModal = true;
        this.serviceRequestService.serviceRequestInServiceRequestModal = request;
        event.stopPropagation();
    }

    toggleCheck(selectedItem): void {
        const checked = selectedItem.checked;
        this.uncheckItem();
        if (checked && this.serviceRequestService.selectedItemData) {
            this.serviceRequestService.toggleDetailedView(null, false);
        } else {
            selectedItem.checked = true;
            this.serviceRequestService.toggleDetailedView(selectedItem, true);
        }
    }

    uncheckItem(): void {
        this.serviceRequestService.data.allServiceRequests.data.forEach((item) => item.checked = false);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/service-request/service-request-list/service-request-list.component.ts